module.exports = __webpack_public_path__ + "img/paimon.08ace524.webp";